
export const SERVER_HOST = 'https://demo.lfs.rest/api/v3/';
export const SERVER_HOST_QR = 'https://demo.lfs.rest/api/v4/'
